import React, { createContext, useContext, useCallback, useMemo } from "react";
import { useAdvisorPageTracking } from "../hooks/useAdvisorPageTracking";
import { useClientPageTracking } from "../hooks/useClientPageTracking";

const PageTrackingContext = createContext({ trackTab: () => {} });

export function usePageTracking() {
  return useContext(PageTrackingContext);
}

export function PageTrackingProvider({ children }) {
  // Both hooks run on every render; each is internally gated by role and
  // becomes a no-op for the other audience, so calling both is safe.
  const advisor = useAdvisorPageTracking();
  const client = useClientPageTracking();

  const trackTab = useCallback(
    (...args) => {
      advisor.trackTab(...args);
      client.trackTab(...args);
    },
    [advisor, client]
  );

  const value = useMemo(() => ({ trackTab }), [trackTab]);

  return (
    <PageTrackingContext.Provider value={value}>
      {children}
    </PageTrackingContext.Provider>
  );
}
